import useSuspenseQuery from '@simppl/react-query/useSuspenseQuery';
import { subjectAPI } from '@simppl/repository-admin/test';

export function useSubjects() {
  const ib = useSuspenseQuery({
    queryKey: ['get-subjects', 'ib-subjects'],
    queryFn: () => subjectAPI.get({ curriculum: 'IB' }),
  });

  const ap = useSuspenseQuery({
    queryKey: ['get-subjects', 'ap-subjects'],
    queryFn: () => subjectAPI.get({ curriculum: 'AP' }),
  });

  const aLevel = useSuspenseQuery({
    queryKey: ['get-subjects', 'alevel-subjects'],
    queryFn: () => subjectAPI.get({ curriculum: 'A-LEVEL' }),
  });

  return {
    IB: ib.data.map((v) => ({ ...v, subject: 'IB' as const })),
    AP: ap.data.map((v) => ({ ...v, subject: 'AP' as const })),
    'A-LEVEL': aLevel.data.map((v) => ({ ...v, subject: 'A-LEVEL' as const })),
  };
}
